/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import { size as boxSize } from 'polished';

import Responsive from 'app/components/responsive/Responsive';
import PlayerStatsIcon from 'app/images/onesport/player-stats-icon.svg';

const PlayerAvatar = ({
  className,
  fallbackText,
  image,
  size = 'default',
  showStatsIcon = false,
  reverseLayout = false,
  isCompletedView = false
}: Props) => {
  return (
    <PlayerAvatarBox className={className} image={image} size={size}>
      {showStatsIcon && (
        <Responsive tabletLandscape desktop>
          {isLargeScreen => (
            <PlayerStats
              src={PlayerStatsIcon}
              reverseLayout={reverseLayout}
              isCompletedView={isCompletedView}
              isLargeScreen={isLargeScreen}
            />
          )}
        </Responsive>
      )}
      {!image && fallbackText}
    </PlayerAvatarBox>
  );
};

export default PlayerAvatar;

interface Props {
  className?: string;
  fallbackText?: string;
  image?: string;
  size?: 'small' | 'default' | 'large' | 'xlarge';
  showStatsIcon?: boolean;
  reverseLayout?: boolean;
  isCompletedView?: boolean;
}

const PlayerStats = styled.img(({ reverseLayout, isCompletedView, isLargeScreen }) => ({
  width: '14px',
  height: '14px',
  position: 'absolute',
  top: isCompletedView && !isLargeScreen ? '7px' : '14px',
  transform: reverseLayout
    ? isCompletedView && !isLargeScreen
      ? 'translateX(16px)'
      : 'translateX(24px)'
    : isCompletedView && !isLargeScreen
    ? 'translateX(-16px)'
    : 'translateX(-24px)'
}));

const PlayerAvatarBox = styled.div(
  {
    alignItems: 'center',
    borderRadius: '50%',
    boxSizing: 'content-box',
    color: 'white',
    display: 'flex',
    flexBasis: 'auto',
    flexGrow: 0,
    flexShrink: 0,
    fontSize: '1.2rem',
    justifyContent: 'center',
    letterSpacing: '0.05em',
    textIndent: '0.05em',
    cursor: 'pointer'
  },
  ({ image, theme }) =>
    image
      ? {
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          borderColor: theme.color.basis6,
          borderStyle: 'solid',
          borderWidth: 1
        }
      : {
          backgroundColor: theme.color.basis5
        },
  ({ size }) =>
    ({
      small: {
        ...boxSize(20),
        fontSize: '0.8rem'
      },
      default: {
        ...boxSize(40),
        fontSize: '1.2rem'
      },
      large: {
        ...boxSize(60),
        fontSize: '1.6rem'
      },
      xlarge: {
        ...boxSize(80),
        fontSize: '2rem'
      }
    }[size])
);
